import { render, staticRenderFns } from "./PostSave.vue?vue&type=template&id=60bb0a00&scoped=true"
import script from "./PostSave.vue?vue&type=script&lang=js"
export * from "./PostSave.vue?vue&type=script&lang=js"
import style0 from "./PostSave.vue?vue&type=style&index=0&id=60bb0a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb0a00",
  null
  
)

export default component.exports